module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container\"> <div class=\"row my-7\"> <div class=\"col-sm-6 col-md-4 mx-auto\"> <h3>Verify Your Email</h3> <p>You should receive an email with a verification link shortly. Once you verify your email with the link, you'll be able to log in and use EasyPost!</p> <p>If the link doesn't work, please try your code below.</p> <form id=\"email_verification_form\"> <div class=\"form-group\"> <input class=\"form-control\" id=\"email_verification_code\" name=\"email_verification[code]\" placeholder=\"Verification Code\" type=\"text\"> </div> <button class=\"btn btn-lg btn-secondary pull-right\" type=\"submit\">Verify</button> </form> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/verification_splash/template.ejs
// module id = 1185
// module chunks = 1